/**
 * ============================================================================
 * 导航栏内容 - Navigation Content
 * ============================================================================
 *
 * 【作用】控制顶部导航栏每个菜单项显示的文字（中/英）。
 * 【如何修改】直接改下面对象中对应键的 en / cn 字符串；键名（home, research 等）需与 App 中路由一致，勿删。
 *
 * 【参数说明】每个键对应一个页面，值为 { en: "英文", cn: "中文" }。
 */

export const navContent = {
  home: { en: "Home", cn: "首页" },
  research: { en: "Research", cn: "研究内容" },
  publications: { en: "Publications", cn: "发表论文" },
  teaching: { en: "Teaching", cn: "课程教学" },
  team: { en: "Team", cn: "团队成员" },
  news: { en: "News", cn: "新闻动态" },
  openings: { en: "Openings", cn: "开放位置" },
  contact: { en: "Contact", cn: "联系我们" }
};
